import { Phone } from "lucide-react";
import PageHero from "../components/PageHero";
import CtaBanner from "../components/CtaBanner";
import { CASES, PHONE_LINK, Reveal } from "../lib/data";

const CazuriPage = () => (
  <>
    <PageHero
      pageTitle="Cazuri"
      eyebrow="Cazuri & rezultate"
      title="Zâmbete transformate la MEDAS"
      desc="O selecție de tratamente reușite de echipa noastră. Rezultatul tău poate fi următorul."
    />
    <section className="pb-20 lg:pb-28 bg-white" data-testid="cases-section">
      <div className="max-w-7xl mx-auto px-6 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {CASES.map((c, i) => (
          <Reveal key={c.title} delay={(i % 3) * 0.08}>
            <a
              href={PHONE_LINK}
              data-testid={`case-card-${i}`}
              className="group block h-full bg-[#FBF7EF] rounded-2xl border border-[#EADFC6] overflow-hidden hover:shadow-xl hover:shadow-[#A6823B]/10 hover:-translate-y-1 transition-all"
            >
              <div className={`overflow-hidden aspect-[4/3] ${c.contain ? "bg-[#1A1712]" : ""}`}>
                {c.video ? (
                  <video
                    src={c.video}
                    poster={c.img}
                    autoPlay
                    muted
                    loop
                    playsInline
                    ref={(v) => { if (v) { v.muted = true; v.play().catch(() => {}); } }}
                    data-testid={`case-video-${i}`}
                    className="w-full h-full object-contain group-hover:scale-105 transition-transform duration-700"
                  />
                ) : (
                  <img
                    src={c.img}
                    alt={c.title}
                    loading="lazy"
                    className={`w-full h-full group-hover:scale-105 transition-transform duration-700 ${c.contain ? "object-contain" : "object-cover"}`}
                  />
                )}
              </div>
              <div className="p-6">
                <span className="text-xs font-semibold uppercase tracking-widest text-[#A6823B]">{c.tag}</span>
                <h3 className="font-display font-bold text-[#2A2521] text-lg mt-1.5">{c.title}</h3>
                <p className="text-sm text-[#6B5C43] mt-2 leading-relaxed">{c.desc}</p>
                <span className="mt-4 inline-flex items-center gap-2 text-sm font-semibold text-[#A6823B]">
                  <Phone className="w-4 h-4" /> Vreau și eu așa
                </span>
              </div>
            </a>
          </Reveal>
        ))}
      </div>
    </section>
    <CtaBanner />
  </>
);

export default CazuriPage;
